<div class="cogs-container" *ngIf="cogs$ | async as cogs">
    <div class="cogs-header">
        <span>Estimated Cost Savings: <b [ngClass]="getTotalSavingsClass(formatTo(cogs.Total_Savings))">${{formatTo(cogs.Total_Savings)}}</b></span>
    </div>
    <hr class="cogs-divider">
    <div class="cogs-header">
        <span>Total Cost of Reference Bit: <b>${{formatTo(cogs.Total_Cost)}}</b></span>
    </div>
    <hr class="cogs-divider">
    
    <table class="cogs-table">
        <thead>
            <tr>
                <th style="width: 45%"></th>
                <th style="width: 20%">Reference</th>
                <th style="width: 20%">RTA</th>
                <th style="width: 15%">Delta</th>
            </tr>
        </thead>
        <tbody>
            <!-- Cutters Section -->
            <tr>
                <th class="cogs-section-header" colspan="4">Cutters</th>
            </tr>
            <tr>
                <td>Primary Cutters</td>
                <td>${{formatTo(cogs.Ref_PrimaryCutter)}}</td>
                <td>${{formatTo(cogs.Rta_PrimaryCutter)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_PrimaryCutter, cogs.Ref_PrimaryCutter)">{{getCogDelta(cogs.Rta_PrimaryCutter, cogs.Ref_PrimaryCutter)}}</span></td>
            </tr>
            <tr>
                <td>Backup Elements</td>
                <td>${{formatTo(cogs.Ref_BackupElement)}}</td>
                <td>${{formatTo(cogs.Rta_BackupElement)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_BackupElement, cogs.Ref_BackupElement)">{{getCogDelta(cogs.Rta_BackupElement, cogs.Ref_BackupElement)}}</span></td>
            </tr>
            <tr>
                <td>Overall Leaching Type</td>
                <td><b>{{cogs.Ref_OverallLeach}}</b></td>
                <td><b>{{cogs.Rta_OverallLeach}}</b></td>
                <td></td>
            </tr>
            
            <!-- Body Materials Section -->
            <tr>
                <th class="cogs-section-header" colspan="4">
                    <span>Body Materials (Steel)</span>
                </th>
            </tr>
            <tr>
                <td>Powder</td>
                <td>${{formatTo(cogs.Ref_Powder)}}</td>
                <td>${{formatTo(cogs.Rta_Powder)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_Powder, cogs.Ref_Powder)">{{getCogDelta(cogs.Rta_Powder, cogs.Ref_Powder)}}</span></td>
            </tr>
            <tr>
                <td>Binder</td>
                <td>${{formatTo(cogs.Ref_Binder)}}</td>
                <td>${{formatTo(cogs.Rta_Binder)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_Binder, cogs.Ref_Binder)">{{getCogDelta(cogs.Rta_Binder, cogs.Ref_Binder)}}</span></td>
            </tr>
            <tr>
                <td>Hard Facing</td>
                <td>${{formatTo(cogs.Ref_Hardfacing)}}</td>
                <td>${{formatTo(cogs.Rta_Hardfacing)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_Hardfacing, cogs.Ref_Hardfacing)">{{getCogDelta(cogs.Rta_Hardfacing, cogs.Ref_Hardfacing)}}</span></td>
            </tr>
            <tr>
                <td>Matrix to Steel</td>
                <td></td>
                <td></td>
                <td><span *ngIf="cogs.Delta_Matrix2Steel">${{formatTo(cogs.Delta_Matrix2Steel)}}</span></td>
            </tr>
            
            <!-- Connection Section -->
            <tr>
                <th class="cogs-section-header" colspan="4">Connection</th>
            </tr>
            <tr>
                <td>Upper Section</td>
                <td>${{formatTo(cogs.Ref_Uppersection)}}</td>
                <td>${{formatTo(cogs.Rta_Uppersection)}}</td>
                <td><span [ngClass]="getCogsDeltaColor(cogs.Rta_Uppersection, cogs.Ref_Uppersection)">{{getCogDelta(cogs.Rta_Uppersection, cogs.Ref_Uppersection)}}</span></td>
            </tr>
            <tr>
                <td>One Piece</td>
                <td>{{cogs.Ref_OnePiece ? 'Yes' : 'No'}}</td>
                <td>{{cogs.Rta_OnePiece ? 'Yes' : 'No'}}</td>
                <td></td>
            </tr>
            
            <!-- Justification Section -->
            <tr>
                <th class="cogs-section-header" colspan="4">Justification</th>
            </tr>
            <tr>
                <td colspan="4">
                    <kendo-textarea 
                        class="cogs-justification"
                        [rows]="3" 
                        id="costSavingsJustification" 
                        [(ngModel)]="cogs.Justification"
                        placeholder="Enter justification...">
                    </kendo-textarea>
                </td>
            </tr>
        </tbody>
    </table>
</div>


